import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  authDetails: {},
  personalDetails: {},
  userType: "",
  deliveryPersonId:"",
  loginDetails: {
    jwt: "",
    userType: "",
    userId: null,
    name: "",
    email: "",
    phone_number: "",
    storeId: null,
    stripeAccountId:""
  },
  logoutPopup: false,
  userManagementView: {},
  approvalDetails: {},
  payoutsType: '',
  storeName: '',
  permissions: [],
  isStripeAccount:false
};

const counterSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setUserType: (state, action) => {
      state.userType = action.payload.userType;
    },
    setLoginDetails: (state, action) => {
      state.loginDetails = action.payload;
    },
    setAuthDetails: (state, action) => {
      state.authDetails = action.payload;
    },
    setPersonalDetails: (state, action) => {
      state.personalDetails = action.payload;
    },
    setUserView: (state, action) => {
      state.userManagementView = action.payload;
    },
    setApprovalDetails: (state, action) => {
      state.approvalDetails = action.payload;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
     clearAll: (state) => {
      state.authDetails = {};
      state.personalDetails = {};
    },
      setDeliveryPersonId: (state, action) => {
      state.deliveryPersonId = action.payload;
    },
     setPayoutsType: (state, action) => {
      state.payoutsType = action.payload;
    },
     setStoreName: (state, action) => {
      state.storeName = action.payload;
    },
    setIsStripeAccount: (state, action) => {
      state.isStripeAccount = action.payload;
    },
    setNotificationCount: (state, action) => {
      state.isNotificationUnreadCount = action.payload;
    },
    setIncidentType: (state, action) => {
      state.isNotificationUnreadCount = action.payload;
    },
  },
});

export const {
  setUserType,
  setLoginDetails,
  setUserView,
  setApprovalDetails,
  setPermissions,
  setAuthDetails,
  setPersonalDetails,
  clearAll,
  setDeliveryPersonId,
  setPayoutsType,
  setStoreName,
  setIsStripeAccount,
  setNotificationCount,
  setIncidentType
} = counterSlice.actions;
export default counterSlice.reducer;
